import { PAGE_TEXT } from '../../../../Nomination/components/lang';

const SUPERVISOR_ROLE_TYPE = PAGE_TEXT.SUPERVISOR_TEAM.ROLE_TYPE;
export const DECLARATION_TEXT = {
  CHIEF_SUPERVISOR: 'Chief Supervisor',

  CO_SUPERVISOR: SUPERVISOR_ROLE_TYPE.CO_SUPERVISOR,
  EXTERNAL_CHIEF_JOINT: SUPERVISOR_ROLE_TYPE.EXTERNAL_CHIEF_JOINT,
  EXTERNAL_CHIEF_DUAL: SUPERVISOR_ROLE_TYPE.EXTERNAL_CHIEF_DUAL,
  EXTERNAL_CO_SUPERVISOR: SUPERVISOR_ROLE_TYPE.EXTERNAL_CO_SUPERVISOR,

  /**
   * keep following fields for compatibility with older data in supervisor team section
   * */

  EXTERNAL_CHIEF_SUPERVISOR: SUPERVISOR_ROLE_TYPE.EXTERNAL_CHIEF_SUPERVISOR,
};
